import { ApplicationStatementType } from '../../Types';
import { fetchWrapper } from '../../utils/request';
import { endpoint } from './endpoint';

export async function getApplications() {
  return fetchWrapper(endpoint + `/v1/application`, {
    method: 'get',
  }).then((res) => res.json());
}

export async function getApplicationBasics() {
  return fetchWrapper(endpoint + `/v1/application/basics`, {
    method: 'get',
  }).then((res) => res.json());
}

export async function createApplication(reqBody: {
  name: string;
  customerMessage?: string;
  existingPlan?: string;
}) {
  return fetchWrapper(endpoint + `/v1/application`, {
    method: 'post',
    body: JSON.stringify(reqBody),
  }).then((res) => res.json());
}

interface UpdateApplication {
  id: string;
  displayName?: string;
  completedPlanDiscovery?: boolean;
  contractSigned?: boolean;
}

export async function updateApplication(updates: UpdateApplication) {
  return fetchWrapper(endpoint + `/v1/application/${updates?.id}`, {
    method: 'put',
    body: JSON.stringify({ ...updates }),
  });
}

export async function deleteApplication(id: string) {
  return fetchWrapper(endpoint + `/v1/application/${id}`, {
    method: 'delete',
  });
}

export async function rejectApplication(
  id: string,
  reason: number,
  userFreeText: string,
) {
  return fetchWrapper(endpoint + `/v1/application/${id}/reject`, {
    method: 'put',
    body: JSON.stringify({ reason, userFreeText }),
  });
}

interface ICloneApplication {
  id: string;
  name?: string;
  message?: string;
}
export async function cloneApplication(updates: ICloneApplication) {
  return fetchWrapper(endpoint + `/v1/application/${updates?.id}/clone`, {
    method: 'put',
    body: JSON.stringify({ ...updates }),
  }).then((res) => res.json());
}

interface IAppEditByAdmin {
  applicationId: string;
}
export async function appCreatedByAdmin(updates: IAppEditByAdmin) {
  return fetchWrapper(
    endpoint + `/v1/application/${updates.applicationId}/created-by-admin`,
    {
      method: 'get',
    },
  ).then((res) => res.json());
}

export async function proposeAlternativePlan(
  applicationId: string,
  reason: string,
  freeText: string,
) {
  return fetchWrapper(
    endpoint + `/v1/application/${applicationId}/send-propose-alternative`,
    {
      method: 'post',
      body: JSON.stringify({ reason, freeText }),
    },
  );
}

export async function alignLineAndCalculatePaymentTable(applicationId: string) {
  return fetchWrapper(
    endpoint + `/v1/application/${applicationId}/adjust-lines-payments`,
    {
      method: 'put',
    },
  );
}

export async function createPlanSnapshot(applicationId: string) {
  return fetchWrapper(endpoint + `/v1/application/${applicationId}/snapshot`, {
    method: 'post',
  });
}

interface IApplicationStatement {
  type: ApplicationStatementType;
  value: number;
  extraData: Record<string, unknown>;
}
interface IUpdateApplicationStatements {
  statements: IApplicationStatement[];
  applicationId: string;
}
export async function updateApplicationStatements({
  statements,
  applicationId,
}: IUpdateApplicationStatements) {
  return fetchWrapper(endpoint + `/v1/customer-statements`, {
    method: 'post',
    body: JSON.stringify({ statements, applicationId }),
  }).then((res) => res.json());
}

export async function getApplicationStatements(applicationId: string) {
  return fetchWrapper(
    endpoint + `/v1/customer-statements/?applicationId=${applicationId}`,
    {
      method: 'get',
    },
  ).then((res) => res.json());
}
